export default __webpack_public_path__ + "static/media/lets-go-camping.49dc5eaa.png";